import { log } from '@ms-ows/logging'

import { MultiSurfaceParams, SurfaceParams } from '../models'
import { removeWindowEventListener } from '../utils'

import { getLaunchTime, getPageContext, getSurfaceContainerId } from './state'
import { logElapsedEvent } from './telemetry'

export type SurfaceLaunchType =
  | 'SurfaceLaunched'
  | 'SurfaceControlTriggered'
  | 'SurfaceAATriggered'

export interface IBeaconParameters {
  actionName: string
  actionUrl: string
}

export const SURFACE_DATA_ATTRIBUTE_NAME = 'data-ows'

export const isMultiSurfaceParams = (
  surfaceParams: SurfaceParams | MultiSurfaceParams
): surfaceParams is MultiSurfaceParams =>
  surfaceParams.surfaceType === 'sequence'

export const getRenderAppElementId = () => `${getSurfaceContainerId()}-App`

export const beforeUnload = () => {
  logElapsedEvent(
    log.reserve(0x23602892 /* tag_9yc8s */),
    'SurfaceUnload',
    'unload',
    0,
    getLaunchTime(),
    getPageContext().surfaceId
  )

  removeWindowEventListener('beforeunload', beforeUnload)
}
